module.exports = __webpack_public_path__ + "static-portal/img/7.4eec858.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/7.jpg
// module id = 7jQq
// module chunks = 4